import {createSlice} from '@reduxjs/toolkit';
import {checkLocation} from 'helper';

const DEFAULT_AVATAR = './images/default-avatar.png';


export const liveLocationSlice = createSlice({
    name: 'liveLocation',
    initialState: {
        sharingDuration: null,
        name: '',
        startTime: null,
        userId: null,
        accuracy: null,
        lat: null,
        lng: null,
        timestamp: null, //location generation time
        sharingOn: null,
        browserLat: null,
        browserLng: null,
        formattedAddress: '',
        isLocationExp: null,
        timer: {
            hours: 12,
            mins: 0
        }
    },
    reducers: {
        setLocationData: (state, action) => {
            const {a, g, i, t} = action.payload.firebaseResponse;
            const {startTime, sharingDuration} = state;

            if (checkLocation(startTime, sharingDuration)) {
                state.accuracy = a;
                state.lat = i;
                state.lng = g;
                state.timestamp = t;
                state.sharingOn = true;
            } else {
                state.accuracy = null;
                state.lat = null;
                state.lng = null;
                state.timestamp = null;
                state.sharingOn = false;
            }
        },
        setUserData: (state, action) => {
            const {duration, image_url, name, start_time, user_id} = action.payload;

            const avatarImg = image_url ? image_url : DEFAULT_AVATAR;

            state.sharingDuration = duration;
            state.avatar = avatarImg;
            state.name = name;
            state.startTime = start_time;
            state.userId = user_id;
        },
        getBrowserLocation: (state, action) => {
            state.browserLat = action.payload.browserLat;
            state.browserLng = action.payload.browserLng;
        },
        setFormattedAddress: (state, action) => {
            state.formattedAddress = action.payload;
        },
        setTime: (state, action) => {
            const { hours, mins } = action.payload;
            state.timer = {hours, mins};
        },
        setSharing: (state, action) => {
            state.sharingOn = action.payload;
        },
        setExpired: (state, action) => {
            state.isLocationExp = action.payload;
        },


    },
});

export const {setLocationData, setUserData, getBrowserLocation, setFormattedAddress, setTime, setSharing, setExpired} = liveLocationSlice.actions;


export const selectSharingDuration = state => state.liveLocation.sharingDuration;
export const selectName = state => state.liveLocation.name;
export const selectStartTime = state => state.liveLocation.startTime;
export const selectUserId = state => state.liveLocation.userId;
export const selectAccuracy = state => state.liveLocation.accuracy;
export const selectLat = state => state.liveLocation.lat;
export const selectLng = state => state.liveLocation.lng;
export const selectTimestamp = state => state.liveLocation.timestamp;
export const selectSharingOn = state => state.liveLocation.sharingOn;
export const selectBrowserLat = state => state.liveLocation.browserLat;
export const selectBrowserLng = state => state.liveLocation.browserLng;
export const selectFormattedAddress = state => state.liveLocation.formattedAddress;
export const selectTimer = state => state.liveLocation.timer;

export default liveLocationSlice.reducer;
